import { process } from "../../../Process";
export var orchestratorUrl = function () {
    return "".concat(process.env.NOC_SVC_URL, "/site-power-orchestrator");
};
